import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo } from 'react';
import styled from 'styled-components';
import Icon from '@dbh/icon';
import A from '@dbh/link';
import '@dbh/styled-helpers';
import useFormattedMessage from '@dbh/use-formatted-message-hook';

const CloseA=/*#__PURE__*/styled(A).withConfig({componentId:"sc-1p9o17q-0"})(["display:block;padding:",";"],"1.2rem");CloseA.defaultProps={...A.defaultProps,textUnderline:!1};const CloseButton=/*#__PURE__*/memo(a=>{let{onClick:b,small:c,className:d,icon:e,iconSize:f}=a;const g=f||c?"ff9":"ff4",h=useFormattedMessage("global.tappable_close");return/*#__PURE__*/_jsx(CloseA,{onClick:b,"aria-label":h,tabIndex:0,title:h,className:d},void 0,/*#__PURE__*/_jsx(Icon,{iconSrc:e,iconSize:g}))});CloseButton.displayName="CloseButton";

export { CloseButton as default };
